import { createFileRoute } from "@tanstack/react-router";
import { AutomationsPage } from "@/components/automations/automations-page";
import { OwnerWorkspaceGate } from "@/components/owner-workspace-gate";
import { PageColumn, PageShell } from "@/components/ui/page-shell";
import { useWorkspaceRoot } from "@/lib/api";

/**
 * Automations: the org-wide automation list ("what runs on its own"). Automations
 * are entity-anchored and may be agentless (an external client such as a
 * connected ChatGPT executes them), so they get a workspace-level home rather
 * than living only under agents. Agent-owned automations deep-link to the agent
 * workbench; agentless ones open the workspace detail page.
 */
export const Route = createFileRoute("/$owner/automations/")({
	loader: ({ context: { queryClient }, params }) => {
		void queryClient.prefetchQuery(
			useWorkspaceRoot.queryOptions(params.owner, { slug: params.owner }),
		);
	},
	component: AutomationsIndexPage,
});

function AutomationsIndexPage() {
	const { owner } = Route.useParams();

	return (
		<PageShell className="gap-3 pt-2.5 pb-8">
			<div className="flex min-h-0 min-w-0 flex-1 flex-col">
				<OwnerWorkspaceGate owner={owner}>
					{(props) => (
						<PageColumn className="flex min-h-0 min-w-0 flex-1 flex-col">
							<AutomationsPage
								owner={props.ownerSlug}
								organizationId={props.organizationId}
								isWorkspaceLoading={props.isWorkspaceLoading}
							/>
						</PageColumn>
					)}
				</OwnerWorkspaceGate>
			</div>
		</PageShell>
	);
}
